export default __webpack_public_path__ + "static/DisplaySet-1f4c8af7ffad2a67361c22b30216b843.png";